"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isAddVoucherErrorResponse = exports.Name = exports.AddVoucherFailedEvent = void 0;
var _failedEventData = require("@ori-events/failed-event-data");
const Name = exports.Name = 'add-voucher-failed';
const AddVoucherFailedEvent = exports.AddVoucherFailedEvent = Name;
const isAddVoucherErrorResponse = response => (0, _failedEventData.isErrorResponse)(response);
exports.isAddVoucherErrorResponse = isAddVoucherErrorResponse;
//# sourceMappingURL=index.js.map